import React from 'react'
import RegistrarEmpresa from '../Integration/RegistrarEmpresa'
import DashboardHeader from '../Integration/DashboardHeader'





function PageAddCompany() {





  return (
    <div>
            
<div className="div">
     <DashboardHeader/> 
     </div>

<div className="m-1">
     <RegistrarEmpresa/>
      </div>
            

    
    </div>
  )
}

export default PageAddCompany